import React, { useState } from "react";


import { useHistory } from "react-router-dom";

import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { Actions } from "../../../../client/Actions";
import CustomCard from "../../../components/CustomCard";
import ConfirmWithCommentAndDateButton from "../../../components/button/ConfirmWithCommentAndDateButton";
import ConfirmWithCommentButton from "../../../components/button/ConfirmWithCommentButton";
import { CommentField } from "../../../components/form/simpleFields/CommentField";
import { MiniNavigation } from "../../../components/nav/MiniNavigation";
import { hasFormatsFullAccess } from "../../../helpers/jwt";
import { useModels } from "../../../helpers/models";
import PartsTable from "../../format/PartsTable";


const CommonManagementTable = ({
                                   actionId,
                                   actionType,
                                   twinActionType,
                                   width = 12,
                                   readOnly,
                                   extended,
                                   actionDetails,
                                   title,
                                   format,
                                   commentAsColumn,
                                   model,
                                   setLoader,
                                   commentModel,
                                   withComment,
                                   noDisableRule,
                                   formatId,
                                   customSave,
                                   setReload,
                                   reload,
                                   cleaning,
                                   right,
                                   cleaningValidDuration,
                                   withDate,
                                   saveTitle = "Wykonaj",
                                   twin,
                                   filter
                               }) => {


        const { t } = useTranslation();
        const history = useHistory();
        const models = useModels();

        const [checked, setChecked] = useState([]);
        const [comment, setComment] = useState();
        const [date, setDate] = useState(new Date().toISOString().split('T')[0]);


        function selectAll() {
            setChecked(format.formatParts.filter(p => right ? filter(p) : p.partStatus === "STORAGE"))
        }

        function onSubmit() {
            if (customSave) {
                customSave({
                    parts: checked,
                    comment: comment
                }, reloadData)
            } else {
                Actions.post(`management/${models[actionType].url}/${formatId}${twin ? `/` : ""}${twin ? twinActionType : ""}`,
                    {
                        parts: checked.map(p => p.id),
                        comment: comment,
                        cleaningDate: date
                    },
                    onSaved
                );
            }

        }

        function reloadData() {
            setChecked([])
            setReload(!reload)
        }

        function onSaved(actionId) {
            if (twin) {
                reloadData();
            } else {
                history.push("/management/" + format.id + "/" + models[actionType].url + "/" + actionId)
            }
        }


        const actions = (checked, saveTitle) => {
            return <>
                {actionId && <>
                    <>
                    <span
                        className="badge outline-secondary font-max mr-3">{actionDetails.date || actionDetails.replacementDate}</span>

                    </>
                    <>
                        <span className="badge outline-secondary font-max mr-3">{actionDetails.username}</span>
                    </>
                    <>
                        <span className="badge outline-secondary font-max mr-3">{model.title}</span>
                    </>
                </>
                }
                {!actionId && !readOnly && hasFormatsFullAccess() &&
                    <>
                        <Button type="submit"
                                className={""}
                                onClick={selectAll}
                                variant="outline-secondary">{t("common.select_all")}</Button>
                        {withComment && !withDate &&
                            <ConfirmWithCommentButton type="submit"
                                                      className={"ml-2"}
                                                      comment={comment}
                                                      confirmTitle={<><i
                                                          className={`fa ${(commentModel || models[actionType]).icon} mr-2`}/>{(commentModel || models[actionType]).title}</>}
                                                      setComment={setComment}
                                                      commentRequired={false}
                                                      onConfirm={onSubmit}
                                                      modalSize={"lg"}
                                                      buttonsConf={{
                                                          save: saveTitle ? saveTitle : t("status.start"),
                                                          cancel: t("common.cancel")
                                                      }}
                                                      disabled={checked.length === 0}
                                                      variant="primary">{(saveTitle ? saveTitle : t("status.start")) + " (" + checked.length + ")"}</ConfirmWithCommentButton>
                        }
                        {withComment && withDate &&
                            <ConfirmWithCommentAndDateButton type="submit"
                                                             className={"ml-2"}
                                                             comment={comment}
                                                             date={date}
                                                             confirmTitle={<><i
                                                                 className={`fa ${(commentModel || models[actionType]).icon} mr-2`}/>{(commentModel || models[actionType]).title}</>}
                                                             setComment={setComment}
                                                             setDate={setDate}
                                                             commentRequired={false}
                                                             dateRequired={true}
                                                             onConfirm={onSubmit}
                                                             modalSize={"lg"}
                                                             dateValidation={(date) => {
                                                                 const today = new Date();
                                                                 const actionDate = new Date(date);

                                                                 return actionDate <= today;
                                                             }}
                                                             buttonsConf={{
                                                                 save: saveTitle ? saveTitle : t("status.start"),
                                                                 cancel: t("common.cancel")
                                                             }}
                                                             disabled={checked.length === 0}
                                                             variant="primary">{(saveTitle ? saveTitle : t("status.start")) + " (" + checked.length + ")"}</ConfirmWithCommentAndDateButton>
                        }
                        {!withComment && !withDate &&
                            <Button type="submit"
                                    className={"ml-2"}
                                    onClick={onSubmit}
                                    disabled={checked.length === 0}
                                    variant="primary">{(saveTitle ? saveTitle : t("status.start")) + " (" + checked.length + ")"}</Button>
                        }

                    </>
                }
            </>
        }


        function determineCommentWidth() {
            if (commentAsColumn) {
                return 4
            } else {
                return twin ? 12 : 6
            }
        }

        return (<>


            <Col>

                {!readOnly &&
                    <MiniNavigation
                        actionsLeft={!right && actions(checked, saveTitle)}
                        actionsRight={right && actions(checked, saveTitle)}
                    />
                }

                <Row>
                    <PartsTable
                        className={""}
                        checked={checked}
                        setChecked={setChecked}
                        format={format}
                        reload={reload}
                        extended={extended}
                        title={title}
                        width={(commentAsColumn) ? 8 : 12}
                        readOnly={!!actionId || readOnly}
                        showStatusAlways={readOnly}
                        setLoader={setLoader}
                        twin={twin}
                        cleaning={cleaning}
                        noDisableRule={noDisableRule}
                        additionalFilter={filter}
                        externalState={cleaningValidDuration}
                    />
                    {
                        actionId && withComment && !right &&
                        <CustomCard width={determineCommentWidth()}
                                    className={commentAsColumn ? "" : "mt-2"}
                                    withoutHeader={true}>
                            < CommentField value={actionDetails?.comment} valid={true} readonly={true}/>
                        </CustomCard>
                    }
                </Row>
            </Col>


        </>);
    }
;


export default CommonManagementTable;